import { Context } from "effect";
import type { Effect, Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { HistoryClientFailure } from "../../api/history/model.ts";
import type { HistoryAction, HistorySnapshot, HistorySettlement } from "./model.ts";

import type { StationClientFailure } from "../../api/station/model.ts";

/** Flushes accepted editor writes before taking or restoring a history snapshot. */
export type HistoryFlush = () => Effect.Effect<void, StationClientFailure>;
export class HistoryBrowserIo extends Context.Service<HistoryBrowserIo, {
  readonly promptTagName: Effect.Effect<string | null, HistoryClientFailure>;
  readonly promptTagMessage: Effect.Effect<string | null, HistoryClientFailure>;
  readonly confirmDelete: (name: string) => Effect.Effect<boolean, HistoryClientFailure>;
  readonly confirmTagRestore: (name: string) => Effect.Effect<boolean, HistoryClientFailure>;
  readonly confirmRevisionRestore: (revision: number, path?: string) => Effect.Effect<boolean, HistoryClientFailure>;
  readonly flushPending: (callback: HistoryFlush) => Effect.Effect<void, HistoryClientFailure>;
  readonly reload: Effect.Effect<void, HistoryClientFailure>;
}>()("workerstation/frontend/HistoryBrowserIo") {}
export interface HistorySession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<HistorySnapshot>>;
  readonly read: Effect.Effect<HistorySnapshot>;
  readonly settlements: Effect.Effect<readonly HistorySettlement[]>;
  readonly dispatch: (action: HistoryAction) => Effect.Effect<void>;
}
export class HistorySessions extends Context.Service<HistorySessions, {
  readonly open: (flushPending: HistoryFlush) => Effect.Effect<HistorySession, never, Scope.Scope>;
}>()("workerstation/frontend/HistorySessions") {}
